<div class="cardLayout">
  <ion-row>
    <ion-col size="9">
      <div class="formLabelSemiBoldfs16 mb-5">Competency Dictionary
        <mat-form-field class="mat-height40 mat-input-style ml-10">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchString" (input)="onCompetencySearch(searchString)">
        </mat-form-field>
      </div>
    </ion-col>
    <ion-col size="3" class="text-right d-flex justifyContentEnd">
      <button (click)="downloadDictionary()" title="Download Excel" type="button"
      class="imageIcon center-content fs-14"><span class="ml-5 mr-5 fs-20 material-icons">download</span><span
      class="mr-10">Download</span></button>
      <img [mat-dialog-close] class="cp ml-20 h20" src="././assets/icon/close_icon.png">
    </ion-col>
  </ion-row>
  
  <ion-row class="dropdown-row">
    <ion-col size="3" class="mt-10">
      <ng-multiselect-dropdown 
        class="w-30"
        [placeholder]="'Industry select'" 
        [settings]="dropdownSettings"
        [data]="Industries" 
        [(ngModel)]="selectedIndustries" 
        (onSelect)="onItemSelect($event)"
        (onDeSelect)="onItemDeselect($event)" 
        (onSelectAll)="onSelectAll($event)" 
        (onDeSelectAll)="onDeselectAll()">
      </ng-multiselect-dropdown>
    </ion-col>

    <ion-col size="3" class="mt-10">
      <ng-multiselect-dropdown 
        class="w-30"
        [placeholder]="'Select Sub-Industries'" 
        [data]="SubIndustries" 
        [(ngModel)]="selectedSubIndustries"
        [settings]="dropdownSettings"
        (onSelect)="onSubIndustrySelect($event)"
        (onDeSelect)="onSubIndustryDeselect($event)"
        (onSelectAll)="onSubIndustrySelectAll($event)"
        (onDeSelectAll)="onSubIndustryDeselectAll()">
      </ng-multiselect-dropdown>
    </ion-col>
    <ion-col size="3" class="mt-10">
      <button type="button" class="add_btn fs-14" [style.background-color]="buttonColorName" (click)="submitIndustries()">
        Submit
      </button>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12" class="mt-10">
      <div class="table-wrapper">
        <table class="custom-table rounded-header">
          <thead>
            <tr>
              <th class="font_semibold fs-16">Department/Function</th>
              <th class="font_semibold fs-16">Band/Grade</th>
              <th class="font_semibold fs-16">Competency Name</th>
              <th class="font_semibold fs-16">Competency Definitions</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let competency of competencies">
              <tr *ngFor="let item of competency.competencyMasterlist">
              <td *ngIf="item === competency.competencyMasterlist[0]" [attr.rowspan]="competency.competencyMasterlist.length">{{competency.functionName}}</td>
              <td *ngIf="item === competency.competencyMasterlist[0]" [attr.rowspan]="competency.competencyMasterlist.length">{{competency.band}}</td>
              <td class="fs-14">
                <!-- <ul class="no-bullets"> -->
                  {{item.competencyName}}
                <!-- </ul> -->
              </td>
              <td class="fs-14">
                <!-- <ul class="no-bullets"> -->
                  {{item.competencyDefination}}
                <!-- </ul> -->
              </td>
            </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ion-col>
  </ion-row>
  
  <div class="clear20"></div>
</div>
